export enum DeviceStatus {
  WORKING = "WORKING",
  MISSING = "MISSING",
  FAILED = "FAILED",
  UNAVAILABLE = "UNAVAILABLE",
  UNTESTED = "UNTESTED",
}

// Individual device test result
export type DeviceTestResult = {
  status: DeviceStatus;
  detail?: string;
};

// Container for all device testing results
export type DeviceTestResults = {
  microphoneResult?: DeviceTestResult;
  cameraResult?: DeviceTestResult;
  speakerResult?: DeviceTestResult;
  browserResult?: DeviceTestResult;
};

// Properties to supply to Results component
export type ResultsViewProps = {
  camAccess: boolean;
  micAccess: boolean;
  isInfoFetched: boolean;
  permissionDenied: boolean;
  isMobile: boolean;
};
